import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ColorPickerModule } from "ngx-color-picker";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";

import { FAWMaterialModule } from "./faw-material.module";

@NgModule({
    imports: [
        CommonModule,
        ColorPickerModule,
        FlexLayoutModule,
        ReactiveFormsModule,

        FAWMaterialModule,
    ],

    exports: [
        CommonModule,
        ColorPickerModule,
        FlexLayoutModule,
        ReactiveFormsModule,

        FAWMaterialModule,
    ]
})

export class SharedModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/shared/shared.module.ts